import { LoggerOutput } from './logger-output';
// for datadogLogs
import { DatadogService } from '@services/datadog.service';
import { datadogRum } from '@datadog/browser-rum';

export class DataDogLoggerOutput implements LoggerOutput {
  datadogLogs: any;

  constructor(datadogService: DatadogService) {
    this.datadogLogs = datadogService.getLogs();
  }

  getLogger() {
    return this.datadogLogs?.logger;
  }

  debug(...data: any) {
    this.getLogger()?.debug(data);
  }

  info(...data: any) {
    this.getLogger()?.info(data);
  }

  warn(...data: any) {
    this.getLogger()?.warn(data);
  }

  error(...data: any) {
    this.getLogger()?.error(data);
    datadogRum?.addError(data);
  }

  exception(...data: any) {
    // TODO
    datadogRum?.addError(data);
  }

  event(...data: any) {
    this.getLogger()?.info(data);
  }
}
